module.exports = __webpack_public_path__ + "static/media/ConnectBooks.718ddbc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/ConnectBooks.png
// module id = 422
// module chunks = 0